import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import CardActionArea from '@mui/material/CardActionArea'
import { Link } from 'react-router-dom'
import React from 'react'
import { HelpCenterCardProps } from './_props'
import HelpCenterCardButton from './HelpCenterCardButton'
import sxs from './_styles/HelpCenterCardsSx'

const HelpCenterCard: React.FC<HelpCenterCardProps> = ({
    icon,
    title,
    description,
    handleClick,
    buttonName,
    url,
    colorVariant,
}) => (
    <Card sx={[sxs.card, url ? sxs.cardHoverable : null]}>
        <CardActionArea
            disableRipple={!url}
            disableTouchRipple={!url}
            sx={[sxs.cardActionArea, !url && sxs.cardActionAreaDisabledHover]}
            component={url ? Link : 'div'}
            to={url ?? ''}
            target="_blank"
            rel="noreferrer"
        >
            <CardContent sx={sxs.cardContent}>
                {icon}
                <Typography sx={sxs.cardTitle}>{title}</Typography>
                <Typography sx={sxs.cardDescription}>{description}</Typography>
            </CardContent>
            <HelpCenterCardButton buttonName={buttonName} handleClick={handleClick} colorVariant={colorVariant} />
        </CardActionArea>
    </Card>
)

export default HelpCenterCard
